/**
 * @desc 获取用户审批任务总数
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<number>;
export function request(
  body: defs.activiti.BpmApprovalTaskRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/getApprovalTaskCount`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
